import React from "react";
import { useTechnicianModel } from "../technicianModel";
import { ISearchValue, SearchTypeEnum } from "@/components/YhPageHeader/Types";
import { YhPageHeader } from "@/components/YhPageHeader";
import useGlobalModel from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";
const searchFields = [
    {
        type: SearchTypeEnum.Input,
        span: 4,
        placeholder: "技师名称",
        fieldName: "name",
        size: "small",
    },
    {
        type: SearchTypeEnum.Input,
        span: 4,
        placeholder: "联系电话",
        fieldName: "phone",
        size: "small",
    },
    {
        type: SearchTypeEnum.Select,
        span: 4,
        placeholder: "状态",
        fieldName: "enable",
        size: "small",
        options: [{ label: "开启", value: 1 }, { label: "关闭", value: 0 }]
    }
]

export function PageHeader() {
    const {
        searchParam,
        updateSearchParam,
        resetSearchParam,
        loadData
    } = useTechnicianModel();
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { setLocale } = useGlobalModel()
    const Locale = setLocale(LanguageArr)
    const PageHeaderTitle = <>
    <span style={{ color: "#7F7F7F" }}>{Locale["Basic Data"]} </span>
    <span style={{ color: "#000" }}>/ {Locale["Technician Management"]}</span>
</>
    const searchFields = [
        {
            type: SearchTypeEnum.Input,
            span: 4,
            // placeholder: "技师名称",
            placeholder: Locale["Name"],
            fieldName: "name",
            size: "small",
        },
        {
            type: SearchTypeEnum.Input,
            span: 4,
            // placeholder: "联系电话",
            placeholder: Locale["Phone"],
            fieldName: "phone",
            size: "small",
        },
        {
            type: SearchTypeEnum.Select,
            span: 4,
            // placeholder: "状态",
            placeholder: Locale["Status"],
            fieldName: "enable",
            size: "small",
            options: [{ label: Locale["open"], value: 1 }, { label: Locale["close"], value: 0 }]
        }
    ]
    return (
        <YhPageHeader
            // title="供应商管理"
            title={PageHeaderTitle}
            triggerSearch={true}
            justify="end"
            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            onChange={updateSearchParam}
            handleSearch={loadData}
            handleReset={resetSearchParam}
        />
    );
}